import 'vanilla-cookieconsent/dist/cookieconsent.css';
import * as CookieConsent from 'vanilla-cookieconsent';

let analyticsLoaded = false;

async function loadAnalytics() {
  if (analyticsLoaded) return;
  analyticsLoaded = true;
  const [{ inject }, { injectSpeedInsights }] = await Promise.all([
    import('@vercel/analytics'),
    import('@vercel/speed-insights'),
  ]);
  inject();
  injectSpeedInsights();
}

export function initConsent() {
  CookieConsent.run({
    guiOptions: {
      consentModal: {
        layout: 'box inline',
        position: 'bottom left',
        equalWeightButtons: true,
        flipButtons: false,
      },
      preferencesModal: {
        layout: 'box',
        position: 'right',
        equalWeightButtons: true,
        flipButtons: false,
      },
    },

    categories: {
      necessary: {
        enabled: true,
        readOnly: true,
      },
      analytics: {
        enabled: false,
        readOnly: false,
        services: {
          vercel: {
            label: 'Vercel Analytics & Speed Insights',
            onAccept: () => { loadAnalytics(); },
          },
        },
      },
    },

    language: {
      default: 'en',
      translations: {
        en: {
          consentModal: {
            title: 'We use cookies',
            description:
              'We use a small set of cookies to keep the site working and, with your permission, to understand how visitors use it. Read more in our <a href="#" data-cc="show-preferencesModal">preferences</a>.',
            acceptAllBtn: 'Accept all',
            acceptNecessaryBtn: 'Reject all',
            showPreferencesBtn: 'Manage preferences',
          },
          preferencesModal: {
            title: 'Cookie preferences',
            acceptAllBtn: 'Accept all',
            acceptNecessaryBtn: 'Reject all',
            savePreferencesBtn: 'Save preferences',
            closeIconLabel: 'Close',
            sections: [
              {
                title: 'About these cookies',
                description:
                  'We keep this short. Necessary cookies make the site work. Analytics cookies help us see anonymised traffic stats so we can improve. You can change your mind at any time.',
              },
              {
                title: 'Strictly necessary',
                description:
                  'Required for the site to function — for example, remembering your consent choice.',
                linkedCategory: 'necessary',
              },
              {
                title: 'Analytics',
                description:
                  'Vercel Analytics & Speed Insights — privacy-friendly, no personal data. Helps us understand which pages are popular and how fast the site feels.',
                linkedCategory: 'analytics',
              },
            ],
          },
        },
      },
    },
  });

  if (CookieConsent.acceptedCategory('analytics')) {
    loadAnalytics();
  }
}
